import React from "react"
import PropTypes from "prop-types"

import UtilizationPercentSquare from "../UtilizationPercentSquare"

import "./DeviceUtilizationSummaryCard.scss"

const DeviceUtilizationSummaryCard = ({
  maxInEntity,
  availableDuringPeak,
  avgUsage,
}) => {
  return (
    <div className="UtilizationDetailCard">
      <div className="detail-sections">
        <div className="total-assets">
          <div className="ta-header">TOTAL ASSETS</div>
          <div>{maxInEntity}</div>
        </div>
        <div className="avail-during-peak">
          <div className="avail-header">
            # AVAIL <br /> DURING PEAK
          </div>
          <div>{availableDuringPeak}</div>
        </div>
        <div className="avg-usage-box">
          <div className="avg-header">
            AVG <br /> USAGE
          </div>
          {UtilizationPercentSquare(avgUsage)}
        </div>
      </div>
    </div>
  )
}

DeviceUtilizationSummaryCard.propTypes = {
  maxInEntity: PropTypes.number,
  availableDuringPeak: PropTypes.number,
  avgUsage: PropTypes.number,
}

export default DeviceUtilizationSummaryCard
